import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">热门资源推荐</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">精选各大数字站点最新最热的影视内容</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="group bg-background-100 rounded-lg border border-background-200/60 overflow-hidden cursor-pointer transition-all hover:border-primary-300/60">
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md bg-foreground-950/70 text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-bold whitespace-nowrap">
                    {item.rating}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <span className="text-xs text-primary-600 font-medium">{item.category}</span>
                <h3 className="text-sm font-semibold text-foreground-800 mt-1 line-clamp-1">{item.title}</h3>
                <p className="text-xs text-foreground-400 mt-2">{item.views} 次播放</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}